import React, { useEffect } from "react";
import Button from "../UI/Button/Button";
import "../UI/Button/Button.css";

import "./Download.css";
import AOS from "aos";
import "aos/dist/aos.css";


// const placeholderJobs = [
//   {
//     id: "1",
//     title: "Senior Frontend Engineer",
//     location: "Remote (Global)",
//     department: "Engineering",
//     type: "Full-time",
//     description: "Join our dynamic engineering team to build next-generation user interfaces with React, TypeScript, and Tailwind CSS. Drive innovation and mentor junior developers.",
//     postedDate: "2024-07-28",
//     url: "#"
//   },
//   {
//     id: "2",
//     title: "UX/UI Designer",
//     location: "San Francisco, CA",
//     department: "Design",
//     type: "Full-time",
//     description: "Craft intuitive and visually stunning user experiences for our web and mobile applications. Collaborate closely with product and engineering teams.",
//     postedDate: "2024-07-25",
//     url: "#"
//   },
//   {
//     id: "3",
//     title: "Product Manager - AI Solutions",
//     location: "New York, NY",
//     department: "Product",
//     type: "Full-time",
//     description: "Define and drive the product strategy for our innovative AI-powered solutions. Work with cutting-edge technology and a talented team to deliver market-leading products.",
//     postedDate: "2024-07-22",
//     url: "#"
//   },
//     {
//     id: "4",
//     title: "Marketing Specialist",
//     location: "Austin, TX",
//     department: "Marketing",
//     type: "Part-time",
//     description: "Develop and execute creative marketing campaigns to grow our brand awareness and user base. Focus on digital channels and content creation.",
//     postedDate: "2024-07-20",
//     url: "#"
//   },
// ];


const Download = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <section id="download">
      <div className="container download" data-aos="fade-up">
        <h2>Ingresa a ver nuestras plazas disponibles</h2>
          <div className="header-cta">
            <Button text={"Ir empleos"} btnClass={"btn-dark"} href={"https://empleos502.com"} target={"_blank"} />
            
          </div>        
        

         
        {/* <div data-aos="fade-up" data-aos-delay="200">
          <h2 className="text-3xl font-bold text-neutral-dark mb-8 text-center sm:text-4xl">
            Current Job Openings
          </h2>
          {placeholderJobs.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {placeholderJobs.map((job) => (
                <JobCard key={job.id} job={job} />
              ))}
            </div>
          ) : (
            <p className="text-center text-neutral">
              No job openings at the moment. Please check back later!
            </p>
          )}
        </div> */}
        
      </div>

      
    </section>

    
  );
};

export default Download;
